module.exports = __webpack_public_path__ + "static/img/race2018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/race2018.jpg
// module id = LxK0
// module chunks = 0